import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {
  baseStyles,
  BORDER_RADIUS,
  FIELD_SPACE,
  FORM_INNER_MAX_WIDTH,
  FORM_INNER_WIDE_MAX_WIDTH,
  FORM_INNER_X_WIDE_MAX_WIDTH,
  IMAGE_BORDER_RADIUS, VIEW_BESIDE_PREVIEW_MAX_WIDTH,
  withMediaQueries,
  withMultipleStyles
} from "../../../styles/Styles";
import Space from "../commons/Space";
import {Typography} from "@material-ui/core";
import ValueHelper from "../../utils/ValueHelper";
import constants from "../../constants";
import FileHelper from "../../utils/FileHelper";
import {cloneDeep} from "lodash";
import SingleFilePicker, {
  ACCEPTED_IMAGE_MIMES,
  IMAGE_MAX_SIZE,
  IMAGE_PROFILE_MAX_WIDTH_HEIGHT,
} from "../commons/SingleFilePicker";
import {APP_GAME_DEFAULT_IMAGES_URI} from "../../utils/services";
import {ColorActivityFormImage, ColorTheme} from "../../../styles/Colors";
import FormSectionHeaderView from "../commons/FormSectionHeaderView";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import ApiHelper from "../../utils/ApiHelper";
import {logDebug} from "../../utils/AppLog";
import FullWidthDummyView from "../commons/FullWidthDummyView";
import {SNACKBAR_AUTO_HIDE_DURATION} from "src/js/components/commons/ViewHelper";

const useStyles = (theme) => ({
  videoPreview: {
    borderRadius: BORDER_RADIUS,
    border: '5px solid '+ ColorTheme,
    marginLeft: 32,
    marginRight: 32,
    // marginBottom: 2 * FIELD_SPACE,
    width: 320,
    height: 640,
    [theme.breakpoints.down('md')]: {
      width: 280,
      height: 560,
    }
  },
  imageCustomise: {
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    border: '1px solid rgba(0,0,0,0.03)',
    backgroundColor: ColorActivityFormImage,
    marginBottom: 16,
    padding: 4,
  },
  imageCustomisePlaceholderImage: {
    width: 48,
    height: 48,
    borderRadius: IMAGE_BORDER_RADIUS,
  },
  imageCustomisePlaceholderIcon: {
    width: 48,
    height: 48,
    borderRadius: BORDER_RADIUS,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
});

const CHALLENGE_WINNERS_BY = [
  {'id': 0, 'name': <FormattedMessage id='activity.manage.winnersBy.random'/>},
  {'id': 1, 'name': <FormattedMessage id='activity.manage.winnersBy.topViewed'/>},
  {'id': 2, 'name': <FormattedMessage id='activity.manage.winnersBy.topLiked'/>},
  {'id': 3, 'name': <FormattedMessage id='activity.manage.winnersBy.downloadedOnly'/>},
];

const LAZY_WIN_FUN_WINNERS_BY = [
  {'id': 0, 'name': <FormattedMessage id='activity.manage.winnersBy.topCollectors'/>},
  {'id': 1, 'name': <FormattedMessage id='activity.manage.winnersBy.moreThanValue'/>, 'showWinnersByValue': true},
];

const QUESTIONNAIRE_FUN_WINNERS_BY = [
  {'id': 0, 'name': <FormattedMessage id='activity.manage.winnersBy.questionnaire.top'/>},
  {'id': 1, 'name': <FormattedMessage id='activity.manage.winnersBy.questionnaire.moreThanValue'/>, 'showWinnersByValue': true},
];

const IDENTIFY_LOCATION_FUN_WINNERS_BY = [
  {'id': 0, 'name': <FormattedMessage id='activity.manage.winnersBy.identifyLocation.nearest'/>},
  {'id': 1, 'name': <FormattedMessage id='activity.manage.winnersBy.identifyLocation.lessThanValue'/>, 'showWinnersByValue': true},
];

class ManageActivityDefaults extends React.Component {

  constructor(props) {
    super(props);
    const {activityData} = this.props;
    this.key = 0;

    this.maxGamePlayAudioDuration = 10*1000;
    this.maxBgAudioDuration = 60;
    if (activityData.mediaConfigs) {
      this.maxGamePlayAudioDuration = activityData.mediaConfigs.maxGamePlayAudioDuration;
      this.maxBgAudioDuration = activityData.mediaConfigs.maxBgAudioDuration;
    }

    let contentTypeText = false;
    let contentTypeImage = false;
    let contentTypeAudio = false;
    let contentTypeVideo = false;
    if (activityData.contentTypes && (activityData.type === constants.activity.types.CHALLENGE || activityData.type === constants.activity.types.SOCIAL_CONTENT)) {
      activityData.contentTypes.forEach((value) => {
        if (value == '1') {
          contentTypeText = true;
        } else if (value == '2') {
          contentTypeImage = true;
        } else if (value == '3') {
          contentTypeAudio = true;
        } else if (value == '4') {
          contentTypeVideo = true;
        }
      });
    }

    this.winnersByOptions = LAZY_WIN_FUN_WINNERS_BY;
    if (activityData.type === constants.activity.types.CHALLENGE || activityData.type === constants.activity.types.SOCIAL_CONTENT) {
      this.winnersByOptions = CHALLENGE_WINNERS_BY;
    } else if (activityData.type === constants.activity.types.QUESTIONNAIRE) {
      this.winnersByOptions = QUESTIONNAIRE_FUN_WINNERS_BY;
    } else if (activityData.type === constants.activity.types.IDENTIFY_LOCATION) {
      this.winnersByOptions = IDENTIFY_LOCATION_FUN_WINNERS_BY;
    }

    let winnersBySelected = null;
    this.winnersByOptions.forEach((typeObj) => {
      if (activityData.winnersBy == typeObj.id) {
        winnersBySelected = typeObj;
      }
    });
    if (!winnersBySelected) {
      winnersBySelected = this.winnersByOptions[0];
    }

    let value1PlaceholderAr = activityData.value1PlaceholderAr;
    if (!value1PlaceholderAr && activityData.type === constants.activity.types.PREDICTION) {
      value1PlaceholderAr = activityData.value2Placeholder;
    }

    this.slotMinValues = 0;
    this.slotMaxValues = 0;
    this.slotMinImages = 0;
    this.slotMaxImages = 0;
    this.slotTotalImages = 0;
    this.maxWinOffersCount = 0;
    if (activityData.activityConfigs) {
      this.slotMinValues = activityData.activityConfigs.slotMinValues;
      this.slotMaxValues = activityData.activityConfigs.slotMaxValues;
      this.slotMinImages = activityData.activityConfigs.slotMinImages;
      this.slotMaxImages = activityData.activityConfigs.slotMaxImages;
      this.slotTotalImages = activityData.activityConfigs.slotTotalImages;
      this.maxWinOffersCount = activityData.activityConfigs.maxWinOffersCount;
    }

    this.slotValues = [];
    if (activityData.type === constants.activity.types.JACKPOT
      || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
      || activityData.type === constants.activity.types.GAME_BETTING_PIC
      || activityData.type === constants.activity.types.GAME_ROULETTE
      || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
      || activityData.type === constants.activity.types.GAME_FLIP_CARD
      || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
      || activityData.type === constants.activity.types.GAME_MATCH_PAIR
      || activityData.type === constants.activity.types.GAME_MATCH_THREE
      || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
      || activityData.type === constants.activity.types.GAME_BRAND_RACE
      || activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
      || activityData.type === constants.activity.types.GAME_POKER
      || activityData.type === constants.activity.types.GAME_PUZZLE
      || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
      || activityData.type === constants.activity.types.COLLECT_STARS
      || activityData.type === constants.activity.types.GUESS
      || activityData.type === constants.activity.types.QUESTIONNAIRE
      || activityData.type === constants.activity.types.SURVEY
      || activityData.type === constants.activity.types.SOCIAL_CONTENT
      || activityData.type === constants.activity.types.CHALLENGE
      || activityData.type === constants.activity.types.PREDICTION
      || activityData.type === constants.activity.types.IDENTIFY_LOCATION
    ) {
      if (!activityData.slotValues) {
        activityData.slotValues = [];
      }
      activityData.slotValues.forEach((slotValue) => {
        const option = cloneDeep(slotValue);
        if (!option.imageUrl) {
          option.imageUrl = ApiHelper.getSlotDefaultImageUrl(activityData, slotValue.number);
        }
        option.initialFiles = this.getSlotInitialFiles(option.imageUrl, option.imageFiles);
        this.slotValues.push(option);
      });
    }
    const latitude = activityData.rightOptionHint ? parseFloat(activityData.rightOptionHint) : null;
    const longitude = activityData.rightOptionHintAr ? parseFloat(activityData.rightOptionHintAr) : null;

    this.state = {
      isGamePuzzleSubTypeTap: activityData.subType == 1,
      videoFromGallery: activityData.consumableAt == 1,
      flipsNeeded: activityData.flipsNeeded || '0',
      deadCount: activityData.deadCount || '0',
      gameTime: activityData.gameTime / 1000,
      gameColumns: activityData.gameColumns || '',
      gameRows: activityData.gameRows || '',
      gameSColumns: activityData.gameSColumns || '',
      contactNumber: activityData.feedbackHint || '',
      winnersBySelected: winnersBySelected,
      winnersByValue: activityData.winnersByValue || '0',
      qTitle: activityData.qTitle || '',
      qTitleAr: activityData.qTitleAr || '',
      value1Placeholder: activityData.value1Placeholder || '',
      value1PlaceholderAr: value1PlaceholderAr || '',
      rightOptionHint: activityData.rightOptionHint || '',
      rightOptionHintAr: activityData.rightOptionHintAr || '',
      latitude: latitude,
      longitude: longitude,
      contentTypeText: contentTypeText,
      contentTypeImage: contentTypeImage,
      contentTypeAudio: contentTypeAudio,
      contentTypeVideo: contentTypeVideo,
      imageUrl1: activityData.imageUrl1,
      imageFiles1: activityData.imageFiles1,
      isImageDeleted1: activityData.isImageDeleted1,
      imageUrl2: activityData.imageUrl2,
      imageFiles2: activityData.imageFiles2,
      isImageDeleted2: activityData.isImageDeleted2,
      imageActionUrl: activityData.imageActionUrl,
      imageActionFiles: activityData.imageActionFiles,
      isImageActionDeleted: activityData.isImageActionDeleted,
      bgAudioUrl: activityData.bgAudioUrl,
      bgAudioFiles: activityData.bgAudioFiles,
      isBgAudioDeleted: activityData.isBgAudioDeleted,
      gamePlayAudioUrl: activityData.gamePlayAudioUrl,
      gamePlayAudioFiles: activityData.gamePlayAudioFiles,
      isGamePlayAudioDeleted: activityData.isGamePlayAudioDeleted,
      actionMessage: activityData.actionMessage,

      winPoints: activityData.winPoints || '0',
      winLimit: activityData.winLimit || '1',
      winILimit: activityData.winILimit || '0',
      activityRewarded: activityData.offer,
      activityRewardedSearch: activityData.offer ? activityData.offer.name : '',
      isActivityRewardedLoading: false,
      showValidationMsg: false,
      reload: false,
    };
  }

  componentDidMount() {
    this.props.moveNextCallback(this);
  }

  componentWillUnmount() {
  }

  updateState(fields) {
    this.setState(fields, () => {
      this.props.onDataUpdated(this.getData(true));
    });
  }

  reloadView() {
    this.updateState({reload: !this.state.reload, showValidationMsg: false});
  }

  getSlotInitialFiles(imageUrl, imageFiles) {
    let initialFiles = null;
    if (imageFiles) {
      initialFiles = cloneDeep(imageFiles);
    } else if (imageUrl) {
      initialFiles = [imageUrl];
    }
    if (!initialFiles) {
      initialFiles = [];
    }
    return initialFiles;
  }

  getRandomWeightage() {
    return Math.max(10, Math.floor((Math.random() * 100)));
  }

  getData(excludeError) {
    const {activityData} = this.props;
    const {
      feedbackHint,
      clickLimit,

      isGamePuzzleSubTypeTap,
      videoFromGallery,
      flipsNeeded,
      deadCount,
      gameTime,
      gameColumns,
      gameRows,
      gameSColumns,
      resetGameDays,
      resetLimitPerUser,
      contactNumber,
      winnersBySelected,
      winnersByValue,
      qTitle,
      qTitleAr,
      value1Placeholder,
      value1PlaceholderAr,
      rightOptionHint,
      rightOptionHintAr,
      contentTypeText,
      contentTypeImage,
      contentTypeAudio,
      contentTypeVideo,
      bgAudioUrl,
      bgAudioFiles,
      isBgAudioDeleted,
      imageUrl1,
      imageFiles1,
      isImageDeleted1,
      imageUrl2,
      imageFiles2,
      isImageDeleted2,
      imageActionUrl,
      imageActionFiles,
      isImageActionDeleted,
      gamePlayAudioUrl,
      gamePlayAudioFiles,
      isGamePlayAudioDeleted,
      actionMessage,

      winPoints,
      winLimit,
      winILimit,
      activityRewarded,
    } = this.state;

    // const contentTypes = [];
    // if (contentTypeText) {
    //   contentTypes.push('1');
    // }
    // if (contentTypeImage) {
    //   contentTypes.push('2');
    // }
    // if (contentTypeAudio) {
    //   contentTypes.push('3');
    // }
    // if (contentTypeVideo) {
    //   contentTypes.push('4');
    // }
    // const eGameRows = gameRows >= 2 && gameRows <= 6 ? gameRows : 3;
    // const eGameColumns = gameColumns >= 2 && gameColumns <= 6 ? gameColumns : 3;
    // const eGameSColumns = gameSColumns >= 2 && gameSColumns <= 6 ? gameSColumns : 3;

    if (!excludeError) {
      if (activityData.type === constants.activity.types.VISITOR_OPINION
        || activityData.type === constants.activity.types.EVENT
        || activityData.type === constants.activity.types.LIKE_USER) {

      } else {
        if (!this.isFieldImageUrl1Correct() || !this.isFieldImageUrl2Correct()) {
          this.updateState({showValidationMsg: true});
          return false;
        }
        if (this.isSlotsIncorrect() || !this.areSlotValuesCorrect()) {
          this.updateState({showValidationMsg: true});
          return false;
        }
      }
    }
    let eSlotValues = null;
    // for (let i = 0; i < this.slotMaxValues; i++) {
    //   if (activityData.slotValues.length <= i) {
    //     break;
    //   }
    //   eSlotValues.push(activityData.slotValues[i]);
    // }
    if (this.slotValues && this.slotValues.length > 0) {
      eSlotValues = [];
      let index = 0;
      this.slotValues.forEach((slotValue) => {
        // if (index < this.slotMaxValues || ((slotValue.imageUrl && !ApiHelper.isPublicAsset(slotValue.imageUrl)) || (slotValue.imageFiles && slotValue.imageFiles.length > 0) || slotValue.isImageDeleted)) {
          eSlotValues.push(slotValue);
        // }
        index++;
      });
    }

    return {
      slotValues: eSlotValues
    };
  }

  isFieldImageUrl1Correct() {
    // const {activityData} = this.props;
    // if (activityData.type === constants.activity.types.GAME_PUZZLE) {
    //   const {
    //     imageUrl1,
    //     imageFiles1,
    //   } = this.state;
    //   return imageUrl1 || (imageFiles1 && imageFiles1.length > 0)
    // }
    return true;
  }

  isFieldImageUrl2Correct() {
    // const {activityData} = this.props;
    // if (activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER) {
    //   const {
    //     imageUrl2,
    //     imageFiles2,
    //   } = this.state;
    //   return imageUrl2 || (imageFiles2 && imageFiles2.length > 0)
    // }
    return true;
  }

  isFieldFlipNeededCorrect() {
    const {activityData} = this.props;
    if (activityData.type === constants.activity.types.GAME_FLIP_CARD
      || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
      || activityData.type === constants.activity.types.GAME_MATCH_PAIR
      || activityData.type === constants.activity.types.GAME_MATCH_THREE
      || activityData.type === constants.activity.types.COLLECT_STARS
    ) {
      const {flipsNeeded} = this.state;
      return flipsNeeded && ValueHelper.getEnglishValue(flipsNeeded) > 0;
    }
    return true;
  }

  isFieldDeadCountCorrect() {
    const {activityData} = this.props;
    if (activityData.type === constants.activity.types.GAME_FLIP_CARD
      || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
      || activityData.type === constants.activity.types.GAME_MATCH_PAIR
    ) {
      const {deadCount} = this.state;
      return deadCount && ValueHelper.getEnglishValue(deadCount) >= 0;
    }
    return true;
  }

  render() {
    const {
      feedbackHint,
      clickLimit,

      isGamePuzzleSubTypeTap,
      videoFromGallery,
      flipsNeeded,
      deadCount,
      gameTime,
      gameColumns,
      gameRows,
      gameSColumns,
      resetGameDays,
      resetLimitPerUser,
      contactNumber,
      winnersBySelected,
      winnersByValue,
      qTitle,
      value1Placeholder,
      value1PlaceholderAr,
      rightOptionHint,
      rightOptionHintAr,
      latitude,
      longitude,
      showValidationMsg,
    } = this.state;
    const {app, activities, activityData, classes, isXS} = this.props;

    // let flipsNeededTextKey = null;
    // let flipsNeededHintKey = null;
    // let deadCountTextKey = null;
    // if (activityData.type === constants.activity.types.COLLECT_STARS) {
    //   flipsNeededTextKey = 'activity.manage.flipsCount';
    // } else if (activityData.type === constants.activity.types.GAME_FIND_HIDDEN) {
    //   flipsNeededTextKey = 'activity.manage.flipsCount';
    //   deadCountTextKey = 'activity.manage.emptyCardsCount';
    // } else if (activityData.type === constants.activity.types.GAME_MATCH_PAIR) {
    //   flipsNeededTextKey = 'activity.manage.flipsCount';
    // } else if (activityData.type === constants.activity.types.GAME_MATCH_THREE) {
    //   flipsNeededTextKey = 'activity.manage.movesLimit';
    // } else if (activityData.type === constants.activity.types.GAME_PUZZLE) {
    //   flipsNeededTextKey = 'activity.manage.movesLimit';
    //   flipsNeededHintKey = 'activity.manage.hintPuzzleMovesCount';
    // } else {
    //   flipsNeededTextKey = 'activity.manage.flipsNeeded';
    //   deadCountTextKey = 'activity.manage.deadCardsCount';
    // }

    // const showGameSubType = activityData.type === constants.activity.types.GAME_PUZZLE;
    const showGameSubType = false;
    const showContentTypes = activityData.type === constants.activity.types.CHALLENGE
      || activityData.type === constants.activity.types.SOCIAL_CONTENT;
    const showGameTime = false;
    // const showGameTime = activityData.type === constants.activity.types.GAME_FLIP_CARD
    //   || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
    //   || activityData.type === constants.activity.types.GAME_MATCH_PAIR
    //   || activityData.type === constants.activity.types.QUESTIONNAIRE
    //   || activityData.type === constants.activity.types.GAME_MATCH_THREE
    //   || activityData.type === constants.activity.types.GAME_PUZZLE
    //   || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE;
    const showGameWinnersBy = false;
    // const showGameWinnersBy = activityData.type === constants.activity.types.CHALLENGE
    //   || activityData.type === constants.activity.types.LIKE_USER
    //   || activityData.type === constants.activity.types.COLLECT_STARS
    //   || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
    //   || activityData.type === constants.activity.types.GAME_BETTING_PIC
    //   || activityData.type === constants.activity.types.GAME_MATCH_THREE
    //   || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
    //   || activityData.type === constants.activity.types.QUESTIONNAIRE
    //   || activityData.type === constants.activity.types.IDENTIFY_LOCATION;

    let winnersByValuePlaceholderKey = null;
    if (activityData.type === constants.activity.types.QUESTIONNAIRE) {
      winnersByValuePlaceholderKey = 'activity.manage.questionnaire.minCorrectAnsToWinEligible'
    } else if (activityData.type === constants.activity.types.IDENTIFY_LOCATION) {
      winnersByValuePlaceholderKey = 'activity.manage.identifyLocation.minKmsToWinEligible'
    } else {
      winnersByValuePlaceholderKey = 'activity.manage.minValueToWinEligible'
    }

    // const hideBg = activityData.type === constants.activity.types.LIKE_USER
    //   || activityData.type === constants.activity.types.COLLECT_STARS
    //   || activityData.type === constants.activity.types.GAME_PUZZLE
    //   || activityData.type === constants.activity.types.JACKPOT
    //   || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
    //   || activityData.type === constants.activity.types.GAME_BETTING_PIC
    //   || activityData.type === constants.activity.types.GAME_ROULETTE
    //   || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
    //   || activityData.type === constants.activity.types.GAME_FLIP_CARD
    //   || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
    //   || activityData.type === constants.activity.types.GAME_MATCH_PAIR
    //   || activityData.type === constants.activity.types.GAME_MATCH_THREE
    //   || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
    //   || activityData.type === constants.activity.types.GAME_BRAND_RACE
    //   || activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
    //   || activityData.type === constants.activity.types.GAME_POKER
    //   || activityData.type === constants.activity.types.GAME_PUZZLE;

    const minWidth = Math.min(window.appWidth - 24, 360);
    return (
      <div className={classes.viewColumnFullWidth}>
        <div className={classes.viewRowFullWidthNoCenter} style={{justifyContent: 'center', flexWrap: 'wrap'}}>
          <div style={{width: '100%', maxWidth: isXS ? window.appWidth : VIEW_BESIDE_PREVIEW_MAX_WIDTH, marginBottom: 1.2 * FIELD_SPACE}}>
            {!isXS ? <FullWidthDummyView /> : null}
            <div className={classes.formActivityNoBgNoBorder} style={{maxWidth: isXS ? window.appWidth : VIEW_BESIDE_PREVIEW_MAX_WIDTH}}>
              <div className={classes.flexColumn} style={{justifyContent: 'center'}}>
                {activityData.activityConfigs.slotTotalImages - activityData.activityConfigs.slotMaxImages > 0 ?
                  <div style={{minWidth: minWidth}}>
                    {this.getSlotValuesView()}
                  </div>
                  : null
                }
                {/*{this.slotValues.length > this.slotTotalImages ?*/}
                {/*  <div style={{minWidth: minWidth}}>*/}
                {/*    {this.getReverseSlotValuesView()}*/}
                {/*  </div>*/}
                {/*  : null*/}
                {/*}*/}
              </div>
            </div>
          </div>
        </div>

        {this.renderSnackBar()}
      </div>
    )
  }

  renderSnackBar() {
    const {showSnackbar, snackbarInfo} = this.state;
    if (showSnackbar) {
      const {snackbarMessageId, snackbarMessage, snackbarType} = snackbarInfo;
      const onClose = () => {
        this.setState({showSnackbar: false, snackbarInfo: null});
      };
      let message = snackbarMessage;
      if (!message && snackbarMessageId) {
        message = <FormattedMessage id={snackbarMessageId}/>;
      }
      return (
        <Snackbar open={message != null} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION} onClose={onClose}>
          <MuiAlert severity={snackbarType || "success"} onClose={onClose} elevation={6} variant="filled">
            {message}
          </MuiAlert>
        </Snackbar>
      );
    }
  }

  showSnackbar(snackbarInfo) {
    if (snackbarInfo) {
      this.setState({showSnackbar: true, snackbarInfo});
    }
  }

  getFormSectionHeaderView(section) {
    const {classes} = this.props;
    return (
      <FormSectionHeaderView classes={classes} section={section} onToggle={this.onFormSectionToggle} />
    );
  }

  getContainerMaxWidth() {
    const {activityData} = this.props;
    let maxPossibleWidth = FORM_INNER_WIDE_MAX_WIDTH;
    if (activityData.type === constants.activity.types.PREDICTION) {
      maxPossibleWidth = FORM_INNER_X_WIDE_MAX_WIDTH;
    }
    return Math.min(window.appWidth, maxPossibleWidth);
  }

  isSlotsIncorrect() {
    // return !this.slotValues || this.slotValues.length < this.slotMinValues || this.slotValues.length > this.slotMaxValues;
    return false;
  }

  areSlotValuesCorrect() {
    // const {activityData} = this.props;
    // if (this.slotValues) {
    //   for (let i = 0; i < this.slotValues.length; i++) {
    //     const slotValue = this.slotValues[i];
    //     if (activityData.type === constants.activity.types.JACKPOT) {
    //       if ((!slotValue.imageUrl && (!slotValue.imageFiles || slotValue.imageFiles.length === 0)) || !this.isValueCorrect(slotValue.points)) {
    //         return false;
    //       }
    //     } else if (activityData.type === constants.activity.types.COLLECT_STARS
    //       || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
    //       || activityData.type === constants.activity.types.GAME_MATCH_THREE
    //       || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
    //       || activityData.type === constants.activity.types.GAME_POKER
    //     ) {
    //       if ((!slotValue.imageUrl && (!slotValue.imageFiles || slotValue.imageFiles.length === 0)) || !this.isValueCorrect(slotValue.value1)) {
    //         return false;
    //       }
    //     } else if (activityData.type === constants.activity.types.GAME_FLIP_CARD
    //       || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
    //       || activityData.type === constants.activity.types.GAME_MATCH_PAIR
    //       || activityData.type === constants.activity.types.GAME_BETTING_PIC
    //       || activityData.type === constants.activity.types.GAME_ROULETTE
    //       || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
    //       || activityData.type === constants.activity.types.GAME_BRAND_RACE
    //     ) {
    //       if ((!slotValue.imageUrl && (!slotValue.imageFiles || slotValue.imageFiles.length === 0))) {
    //         return false;
    //       }
    //     }
    //   }
    // }
    return true;
  }

  getSlotValuesView() {
    const {classes, isXS} = this.props;
    const views = [];
    for (let i = this.slotMaxValues; i < this.slotTotalImages; i++) {
      views.push(this.getSlotValueView(i, this.slotValues[i], i > 0 ? this.slotValues[i-1] : null));
    }
    // reverse slot images
    if (this.slotValues.length > this.slotTotalImages) {
      for (let i = this.slotTotalImages; i < this.slotValues.length; i++) {
        views.push(this.getSlotValueView(i, this.slotValues[i], i > 0 ? this.slotValues[i - 1] : null));
      }
    }
    return (
      <div className={classes.imageCustomise}>
        <Typography variant={isXS ? "caption" : "body2"} color={'textSecondary'} style={{marginLeft: 8, marginRight: 8}}>
          {this.context.intl.formatMessage({id: 'activity.gameDefaultImages'})}
        </Typography>
        <div className={classes.viewFullWidthWrap}>
          {views}
        </div>
      </div>
    );
  }

  getReverseSlotValuesView() {
    const {classes, isXS} = this.props;
    const views = [];
    for (let i = this.slotTotalImages; i < this.slotValues.length; i++) {
      views.push(this.getSlotValueView(i, this.slotValues[i], i > 0 ? this.slotValues[i-1] : null));
    }
    return (
      <div className={classes.viewRow}>
        <div className={classes.imageCustomise}>
          <Typography variant={isXS ? "caption" : "body2"} color={'textSecondary'} style={{marginLeft: 8, marginRight: 8}}>
            {this.context.intl.formatMessage({id: this.props.activityData.type === constants.activity.types.GAME_BRAND_RACE ? 'activity.gamePullBackImage' : 'activity.gameReverseImage'})}
          </Typography>
          <div className={classes.viewFullWidthWrap}>
            {views}
          </div>
        </div>
      </div>
    );
  }

  getSlotValueView(optionIndex, item, prevItem) {
    const {showValidationMsg} = this.state;
    const {activityData, classes} = this.props;

    let isPlaceholderImageRequired = false;

    let isDisabled = true;
    if (!prevItem || (prevItem.imageUrl && !ApiHelper.isPublicAsset(prevItem.imageUrl)) || (prevItem.imageFiles && prevItem.imageFiles.length > 0)) {
      isDisabled = false;
    }

    return (
      <div style={{margin: 2}}>
        <SingleFilePicker
          // disabled={isDisabled}
          key={this.key +'-slot-'+ optionIndex} // added to reload ui and correctly putting the images in multiple slots
          id={this.key +'-slot-'+ optionIndex}
          name={this.key +'-slot-'+ optionIndex}
          // label={placeholderLabel}
          required={isPlaceholderImageRequired}
          hideDropzoneText={true}
          size={'xsmall'}
          filesLimit={1}
          acceptedFiles={ACCEPTED_IMAGE_MIMES}
          maxFileSize={IMAGE_MAX_SIZE}
          maxWidthOrHeight={IMAGE_PROFILE_MAX_WIDTH_HEIGHT}
          aspectRatio={1}
          initialFiles={item.initialFiles}
          error={showValidationMsg && !item.imageUrl && (!item.imageFiles || item.imageFiles.length === 0)}
          errorText={showValidationMsg && !item.imageUrl && (!item.imageFiles || item.imageFiles.length === 0) ? <FormattedMessage id='generic.validation.required' /> : null}
          onChange={(files) => {
            this.onChangeSlotFiles(files, optionIndex);
          }}
          onDelete={(file) => {
            this.onDeleteSlotFile(file, optionIndex);
          }}
        />
      </div>
    );

    return (
      <div className={classes.imageCustomise} key={optionIndex}>
        <div className={classes.flexRow}>
          <img className={classes.imageCustomisePlaceholderImage} src={imageSrc}/>
          <Space verticalSpace={1}/>
          <div className={classes.flexColumnNoCenter}>
            <Typography variant="body1" color={'textSecondary'}>
              {this.context.intl.formatMessage({id: imageLabelId})}
            </Typography>
            <Typography variant="caption" color={'textSecondary'}>
              {<FormattedMessage id={'activity.manage.placeholderImageDescription'} />}
            </Typography>
          </div>
          <Space verticalSpace={1.5}/>
          <div style={{margin: -4}}>
            <SingleFilePicker
              disabled={isDisabled}
              key={this.key +'-slot-'+ optionIndex} // added to reload ui and correctly putting the images in multiple slots
              id={this.key +'-slot-'+ optionIndex}
              name={this.key +'-slot-'+ optionIndex}
              // label={placeholderLabel}
              required={isPlaceholderImageRequired}
              hideDropzoneText={true}
              size={'small'}
              filesLimit={1}
              acceptedFiles={ACCEPTED_IMAGE_MIMES}
              maxFileSize={IMAGE_MAX_SIZE}
              maxWidthOrHeight={IMAGE_PROFILE_MAX_WIDTH_HEIGHT}
              aspectRatio={1}
              initialFiles={item.initialFiles}
              error={showValidationMsg && !item.imageUrl && (!item.imageFiles || item.imageFiles.length === 0)}
              errorText={showValidationMsg && !item.imageUrl && (!item.imageFiles || item.imageFiles.length === 0) ? <FormattedMessage id='generic.validation.required' /> : null}
              onChange={(files) => {
                this.onChangeSlotFiles(files, optionIndex);
              }}
              onDelete={(file) => {
                this.onDeleteSlotFile(file, optionIndex);
              }}
            />
          </div>
        </div>
      </div>
    );
  }

  isValueCorrect(value) {
    return value && parseInt(ValueHelper.getEnglishValue(value)) >= 0;
  }

  onAddNewSlotValueClicked = () => {
    if (!this.slotValues) {
      this.slotValues = [];
    }
    this.slotValues.push({
      points: '0',
      value1: this.getRandomWeightage(),
      winLimit: this.slotValues.length === 0 ? '1' : '0',
      winILimit: '0',
      imageUrl: null,
      initialFiles: [],
    });
    this.reloadView();
  };

  onCenterChanged = (data) => {
    let {latitude, longitude} = this.state;
    if (data) {
      latitude = data.center.lat;
      longitude = data.center.lng;
    }
    this.updateState({
      latitude: latitude,
      longitude: longitude,
      rightOptionHint: ''+ latitude,
      rightOptionHintAr: ''+ longitude,
    });
  };

  onSelectWinnersBySelected = (value) => {
    this.updateState({
      winnersBySelected: value.id,
      showValidationMsg: false,
      isBusinessLoading: false,
    });
  };

  onChangeSlotFiles(files, id) {
    let eImageUrl = this.slotValues[id].imageUrl;

    let lFiles = null;
    let lFileUrl = null;
    if (files && files.length > 0) {
      files.forEach((file) => {
        if (FileHelper.isFileNameSame(file, eImageUrl)) {
          lFileUrl = eImageUrl;
        } else {
          if (!lFiles) {
            lFiles = [];
          }
          lFiles.push(file);
        }
      });
    }

    this.slotValues[id].imageUrl = lFileUrl;
    this.slotValues[id].imageFiles = lFiles;
    this.reloadView();
  }

  onDeleteSlotFile(file, id) {
    let eImageUrl = this.slotValues[id].imageUrl;
    let eImageFiles = this.slotValues[id].imageFiles;

    let lFiles = [];
    let lFileUrl = eImageUrl;
    if (eImageFiles) {
      let index = 0;
      eImageFiles.forEach(lFile => {
        if (FileHelper.areFilesSame(lFile, file)) {
          lFiles.push(lFile);
        }
      });
      lFiles = eImageFiles.filter(x => !lFiles.includes(x));
    }
    if (FileHelper.isFileNameSame(file, eImageUrl)) {
      lFileUrl = null;
    }

    this.slotValues[id].imageUrl = lFileUrl;
    this.slotValues[id].imageFiles = lFiles;
    this.slotValues[id].isImageDeleted = true;
    this.reloadView();
  }

  onErrorFiles = (error) => {
    this.showSnackbar({
      snackbarMessage: error,
      snackbarType: "error",
    });
  };

  onChangeFiles(files, id) {
    const {
      imageUrl1,
      imageUrl2,
      bgAudioUrl
    } = this.state;

    let eImageUrl = null;
    let keyImageUrl = null;
    let keyImageFiles = null;
    if (id === 'imageUrl1') {
      eImageUrl = imageUrl1;
      keyImageUrl = 'imageUrl1';
      keyImageFiles = 'imageFiles1';
    } else if (id === 'imageUrl2') {
      eImageUrl = imageUrl2;
      keyImageUrl = 'imageUrl2';
      keyImageFiles = 'imageFiles2';
    } else if (id === 'bgAudioUrl') {
      eImageUrl = bgAudioUrl;
      keyImageUrl = 'bgAudioUrl';
      keyImageFiles = 'bgAudioFiles';
    }

    let lFiles = null;
    let lFileUrl = null;
    if (files && files.length > 0) {
      files.forEach((file) => {
        if (FileHelper.isFileNameSame(file, eImageUrl)) {
          lFileUrl = eImageUrl;
        } else {
          if (!lFiles) {
            lFiles = [];
          }
          lFiles.push(file);
        }
      });
    }

    this.updateState({showValidationMsg: false, [keyImageUrl]: lFileUrl, [keyImageFiles]: lFiles});
  }

  onDeleteFile(file, id) {
    const {
      imageUrl1,
      imageFiles1,
      imageFiles1O,
      imageUrl2,
      imageFiles2,
      imageFiles2O,
      bgAudioUrl,
      bgAudioFiles,
    } = this.state;

    let eImageUrl = null;
    let eImageFiles = null;
    let keyImageUrl = null;
    let keyImageFiles = null;
    let keyIsImageDeleted = null;
    if (id === 'imageUrl1') {
      eImageUrl = imageUrl1;
      eImageFiles = imageFiles1;
      keyImageUrl = 'imageUrl1';
      keyImageFiles = 'imageFiles1';
      keyIsImageDeleted = 'isImageDeleted1';
    } else if (id === 'imageUrl2') {
      eImageUrl = imageUrl2;
      eImageFiles = imageFiles2;
      keyImageUrl = 'imageUrl2';
      keyImageFiles = 'imageFiles2';
      keyIsImageDeleted = 'isImageDeleted2';
    } else if (id === 'bgAudioUrl') {
      eImageUrl = bgAudioUrl;
      eImageFiles = bgAudioFiles;
      keyImageUrl = 'bgAudioUrl';
      keyImageFiles = 'bgAudioFiles';
      keyIsImageDeleted = 'isBgAudioDeleted';
    }

    let lFiles = [];
    let lFileUrl = eImageUrl;
    if (eImageFiles) {
      let index = 0;
      eImageFiles.forEach(lFile => {
        if (FileHelper.areFilesSame(lFile, file)) {
         lFiles.push(lFile);
        }
        index++;
      });
      lFiles = eImageFiles.filter(x => !lFiles.includes(x));
    }
    if (FileHelper.isFileNameSame(file, eImageUrl)) {
      lFileUrl = null;
    }

    this.updateState({showValidationMsg: false, [keyImageUrl]: lFileUrl, [keyImageFiles]: lFiles, [keyIsImageDeleted]: true});
  }

  onChecked = (event) => {
    const value = event.target.checked;
    this.updateState({[event.target.name]: value, showValidationMsg: false});
  };

  onChange = (event) => {
    let value = event.target.value;
    if (event.target.name === 'feedbackHint' || event.target.name === 'qTitle') {
      value = value.replace("\n", " ");
    } else if (event.target.name === 'winPoints'
      || event.target.name === 'winLimit'
      || event.target.name === 'winILimit'
      || event.target.name === 'clickLimit'
    ) {
      const maxValue = constants.activity.VALUE_DEFAULT_MAX;
      value = ValueHelper.getDecimalValue(value);
      if (ValueHelper.getEnglishValue(value) < 0) {
        value = 0;
      } else if (ValueHelper.getEnglishValue(value) > maxValue) {
        value = maxValue;
      }
    }

    this.updateState({[event.target.name]: value, showValidationMsg: false});
  };

}

ManageActivityDefaults.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  app: PropTypes.object,
  activities: PropTypes.object,
  activityData: PropTypes.object,
  moveNextCallback: PropTypes.func.isRequired,
  onDataUpdated: PropTypes.func.isRequired,
};

ManageActivityDefaults.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    app: state.app,
    activities: state.admin.activities,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
    ['isDrawerHidden', theme => theme.breakpoints.down('sm'), {defaultMatches: true}],
    ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
    ['isMD', theme => theme.breakpoints.down('md'), {defaultMatches: true}]
  ])(ManageActivityDefaults))
);
